/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What a slice DOES beyond paying a reward. Absent means the slice pays its reward and nothing else.
 * @export
 */
export const SpinOutcomeEffect = {
    POINT_MULTIPLIER: 'POINT_MULTIPLIER',
    BONUS_SPIN: 'BONUS_SPIN',
    POINT_PENALTY: 'POINT_PENALTY'
} as const;
export type SpinOutcomeEffect = typeof SpinOutcomeEffect[keyof typeof SpinOutcomeEffect];


export function instanceOfSpinOutcomeEffect(value: any): boolean {
    for (const key in SpinOutcomeEffect) {
        if (Object.prototype.hasOwnProperty.call(SpinOutcomeEffect, key)) {
            if (SpinOutcomeEffect[key as keyof typeof SpinOutcomeEffect] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SpinOutcomeEffectFromJSON(json: any): SpinOutcomeEffect {
    return SpinOutcomeEffectFromJSONTyped(json, false);
}

export function SpinOutcomeEffectFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinOutcomeEffect {
    return json as SpinOutcomeEffect;
}

export function SpinOutcomeEffectToJSON(value?: SpinOutcomeEffect | null): any {
    return value as any;
}

export function SpinOutcomeEffectToJSONTyped(value: any, ignoreDiscriminator: boolean): SpinOutcomeEffect {
    return value as SpinOutcomeEffect;
}

